import { Boundary, Menu, MenuItem, Position } from "@blueprintjs/core"
import CustomPopover from "components/Atoms/CustomPopover"
import React from "react"
import classNames from "utils/classNames"
import CustomTag from "../Atoms/CustomTag"
import CustomOverflowList from "../Molecules/CustomOverflowList"

const OverFlowMenu = ({
  items,
  intent = undefined,
  icon = undefined,
  tagIcon = undefined,
  className = undefined,
  onClick = undefined,
  large = false,
  renderActive = undefined,
  renderText,
  getIntent = undefined,
}) => {
  function renderOverflow(items) {
    return (
      <CustomPopover
        position={Position.BOTTOM}
        content={
          <Menu className="vt-overflow-list-menu">
            {items.map((item, index) => {
              return (
                <MenuItem
                  key={item?.id ?? index}
                  onClick={onClick ? e => onClick(item, index) : null}
                  icon={icon}
                  text={renderText(item, index)}
                  intent={getIntent ? getIntent(item) : undefined}
                />
              )
            })}
          </Menu>
        }
      >
        <CustomTag
          round={true}
          large={large}
          interactive={true}
          intent={intent}
        >
          + {items.length}
        </CustomTag>
      </CustomPopover>
    )
  }

  function renderVisible(item, index) {
    return (
      <div key={item?.id ?? index}>
        <CustomTag
          active={renderActive?.(item, index)}
          large={large}
          icon={tagIcon}
          className="mr-2"
          round={true}
          interactive={onClick ? true : false}
          intent={intent ? intent : getIntent ? getIntent(item) : "none"}
          minimal={true}
          onClick={onClick ? e => onClick(item, index) : null}
        >
          {renderText(item, index)}
        </CustomTag>
      </div>
    )
  }
  return (
    <CustomOverflowList
      className={classNames("vt-custom-overflow-list", className)}
      items={items}
      collapseFrom={Boundary.END}
      overflowRenderer={renderOverflow}
      visibleItemRenderer={renderVisible}
    />
  )
}

OverFlowMenu.defaultProps = {
  renderText: item => (item ? item.name : "na"),
}
export default OverFlowMenu
